import { ShareEventMarket } from './constants';
import { Channel } from './type';

const ShareEventName = 'QSShareToSocialMedia';
const ShareEventVersion = 1;

const ShareFegoEventName = 'ShareFego';
const ShareFegoEventVersion = 1;

const ShareEventChannel = {
    [Channel.FACEBOOK]: '1',
    [Channel.TWITTER]: '2',
    [Channel.TELEGRAM]: '3',
    [Channel.XIAOHONGSHU]: '4',
    [Channel.REDDIT]: '5',
    [Channel.INSTAGRAM]: '6',
    [Channel.WECHAT]: '8',
    [Channel.WECHAT_MOMENTS]: '9',
    [Channel.SYSTEM]: '7'
};

const EventEntityMap = {
    [ShareEventMarket.HK]: 'FUTU_HK',
    [ShareEventMarket.SG]: 'FUTU_SG',
    [ShareEventMarket.MY]: 'FUTU_MY',
    [ShareEventMarket.US]: 'FUTU_US',
    [ShareEventMarket.JP]: 'FUTU_JP',
    [ShareEventMarket.CA]: 'FUTU_CA',
    [ShareEventMarket.AU]: 'FUTU_AU'
};

const ShareFegoEventChannel = {
    [Channel.FACEBOOK]: 'facebook',
    [Channel.TWITTER]: 'x',
    [Channel.TELEGRAM]: 'telegram',
    [Channel.XIAOHONGSHU]: 'xiaohongshu',
    [Channel.REDDIT]: 'reddit',
    [Channel.INSTAGRAM]: 'instagram',
    [Channel.WECHAT]: 'wechat_friend',
    [Channel.WECHAT_MOMENTS]: 'wechat_moments',
    [Channel.SYSTEM]: 'more'
};

const ShareType = {
    // 链接内容组件
    LINK_CONTENT_COMP: '2'
};

export function shareReport({ channel, material_id, string_id, user_home_market, report_attrs }) {
    if (!window.FEGOEditor) {
        const { ftReport } = window.FEGORender?.plugins;
        const pageId = ftReport.getFtReport().getPageId();
        const sessionInfo = JSON.stringify(ftReport.getFtReport().getSessionInfo());
        const reportAttrs = report_attrs || { element_id: '', element_name: '' };
        // 上报到指定的攻略事件
        ftReport.ftReportIns.sdReport({
            eventName: ShareEventName,
            eventVersion: ShareEventVersion,
            eventEntity: EventEntityMap[user_home_market],
            payload: {
                channel_name: ShareEventChannel[channel],
                material_id,
                string_id,
                user_home_market
            }
        });
        // 上报到FEGO通用分享事件
        ftReport.ftReportIns.sdReport({
            eventName: ShareFegoEventName,
            eventVersion: ShareFegoEventVersion,
            payload: {
                page_id: pageId,
                channel_name: ShareFegoEventChannel[channel],
                share_type: ShareType.LINK_CONTENT_COMP,
                $element_id: reportAttrs.element_id,
                $element_name: reportAttrs.element_name,
                session_info: sessionInfo
            }
        });
    }
}
